"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommitedStateScope = exports.useCommitedState = void 0;
var react_1 = __importStar(require("react"));
var idCounter = 0;
var check = function (s) {
    var res = false;
    for (var itemId in s) {
        var v = s[itemId];
        if (v.json == null || (JSON.stringify(v.state) != v.json)) {
            res = true;
            break;
        }
    }
    return res;
};
var CommitedStateContext = (0, react_1.createContext)({});
var useCommitedState = function (state) {
    var scope = (0, react_1.useContext)(CommitedStateContext);
    var id = (0, react_1.useState)(function () {
        return ++idCounter;
    })[0];
    var _a = (0, react_1.useState)(0), commitCounter = _a[0], setCommitCounter = _a[1];
    var _b = (0, react_1.useState)(false), isUncommited = _b[0], setIsUncommited = _b[1];
    var value = (0, react_1.useMemo)(function () {
        var v = scope[id];
        if (!v) {
            v = { state: state, json: null, setIsUncommited: setIsUncommited };
            scope[id] = v;
        }
        return v;
    }, [id, scope]);
    (0, react_1.useEffect)(function () {
        return function () {
            delete scope[id];
            var res = check(scope);
            for (var itemId in scope) {
                var v = scope[itemId];
                v.setIsUncommited(res);
            }
        };
    }, []);
    value.state = state;
    value.json = (0, react_1.useMemo)(function () {
        return JSON.stringify(state);
    }, [commitCounter]);
    value.setIsUncommited = function (v) {
        if (v != isUncommited) {
            setIsUncommited(v);
        }
    };
    var commit = function () {
        setCommitCounter(commitCounter + 1);
    };
    (0, react_1.useEffect)(function () {
        var res = check(scope);
        for (var itemId in scope) {
            var v = scope[itemId];
            v.setIsUncommited(res);
        }
    }, [value.state, value.json]);
    return [commit, isUncommited];
};
exports.useCommitedState = useCommitedState;
var CommitedStateScope = function (props) {
    return react_1.default.createElement(CommitedStateContext.Provider, { value: {} }, props.children);
};
exports.CommitedStateScope = CommitedStateScope;
//# sourceMappingURL=CommitedState.js.map